import React from 'react';
import { useSelector } from 'react-redux';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';

import { PayWallFullState } from 'components/PayWall/Redux/Reducer.type';

const useStyles = makeStyles({
  totalLabel: {
    fontSize: 16,
    fontWeight: 500,
    position: 'relative',
    top: 7,
  },

  chatButton: {
    textAlign: 'center',
    marginTop: 15,
  },
});

export default function UnsupportedTotal(): JSX.Element {
  const classes = useStyles();
  const { Intercom } = window;
  const selectedPlan = useSelector((state: PayWallFullState) => state.payWall.selectedPlan);
  const selectedDuration = useSelector((state: PayWallFullState) => state.payWall.planSummaryPreview.plan_type);
  const additionalUsers = useSelector(
    (state: PayWallFullState) => state.payWall.planSummaryPreview.additional_users.count
  );
  const orgFeatures = useSelector((state: PayWallFullState) => state.payWall.planSummaryPreview.additional_features);

  function buildSupportUpgradeMessage() {
    const additionalFeatures = orgFeatures.length > 0 ? orgFeatures.map((f) => f.display_name) : 'none';
    return `Hi Support Team,\nPlease change my plan to: ${selectedPlan.display_name}, ${selectedDuration}\nadditional logins: ${additionalUsers}\nadditional features: ${additionalFeatures}\n`;
  }

  return (
    <>
      <div>
        <Typography align="center" className={classes.totalLabel} data-testid="unsupported-change">
          Your plan changes will need to be <br />
          completed by one of our billing specialists.
        </Typography>
      </div>
      <div className={classes.chatButton}>
        <Button
          color="primary"
          onClick={() => {
            Intercom('showNewMessage', buildSupportUpgradeMessage());
          }}
        >
          CHAT NOW
        </Button>
      </div>
    </>
  );
}
